/*
 * @Author: 小周
 * @Date: 2023-09-07 11:51:28
 * @LastEditTime: 2023-09-07 11:51:28
 * @LastEditors: MrZHLF 480970024@qq.com
 * @Description: 接口请求
 */
import axios from 'axios'
import { getToken } from './tokenStore'
const service = axios.create({
  baseURL: '/',
  withCredentials: false,
  timeout: 5000,
})

// request拦截器 request interceptor
service.interceptors.request.use(
  (config) => {
    let token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (response.status && response.status !== 200) {
      return Promise.reject(res)
    } else {
      return Promise.resolve(res)
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)
export default service
